<template>
    <section class="container" style="min-height:50vh">
        <section id="firebaseui-auth-container"></section>
    </section>
</template>

<script>
import navigation from "@/components/NavBar.vue"
import firebase from "firebase/app"
import 'firebase/app'
import * as firebaseui from "firebaseui"
import "firebaseui/dist/firebaseui.css"

export default {
    name: "Login",
    data() {
        return {};
    },
    mounted() {
        let ui = firebaseui.auth.AuthUI.getInstance();
        if (!ui) {
            ui = new firebaseui.auth.AuthUI(firebase.auth());
        }
        var uiConfig = {
            signInSuccessUrl: "/dashboard",

            signInOptions: [
                firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                firebase.auth.EmailAuthProvider.PROVIDER_ID
            ]
        };
        ui.start("#firebaseui-auth-container", uiConfig);
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Login.vue